export const quote = {
  title: "Quote list",
  quoteNumber: "Quote Number",
  quoteRef: "Quote Reference",
  quote_num: "Quote number",
  client: "Client",
  client_name: "Client name",
  startDate: "Start Date",
  start_date: "Start Date",
  issueDate_label: "Quote issue date",
  validityPeriod_label: "Validity period of the offer",
  estimatedDuration_label: "Estimated service duration",
  days: "days",
  amountHT: "Amount (excl. tax) (€)",
  tva: "VAT (%)",
  amountTTC: "Amount (incl. tax) (€)",
  status: "Status",
  status_all: "All statuses",
  "status.pending": "Pending",
  "status.accepted": "Accepted",
  "status.refused": "Refused",
  "status.invoiced": "Invoiced",
  "status.all": "All",
  validity: "Validity (days)",
  dueDate: "Due Date",
  paymentDeadline: "Payment Deadline",
  actions: "Actions",
  edit: "Edit",
  view: "View",
  editQuote: "Edit Quote",
  cancel: "Cancel",
  save: "Save",
  create_btn: "Create quote",
  new_quote: "Create new quote",
  finalize: "Confirm",
  success_created: "Quote created successfully",
  errorExists: "The quote number already exists.",
  errorEdit: "An error occurred while editing.",
  all_clients: "All clients",
  date_placeholder: "mm/dd/yyyy",
  details_quote: "Quote details",
  error_add_offers: "Add offers to your quote",
  consult: "Consult",
  preview: "Quote",
  number: "Quote number",
  startDate_label: "Start Date",
  pending: "Pending",
  estimatedDuration: "Estimated Duration",
  validityPeriod: "Validity Period",
  issueDate: "Issue Date",
  empty_title: "Create a quote",
  empty_description: "Easily create and send your quotes to your clients",
  create_button: "Create a quote",
  error_message_bank:
    " You must add your bank details before creating an invoice.",
  error_add_bank: "Add bank details",
};
